import {
  MyCleaningsHeader,
  MyCleaningsUpcomingList,
} from '@/features/consumer/my-cleanings-bookings';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(consumer)/_authenticated/bookings/')({
  component: BookingPage,
});

function BookingPage() {
  return (
    <div>
      <MyCleaningsHeader active="upcoming" />
      <MyCleaningsUpcomingList />
    </div>
  );
}
